export default "__VITE_ASSET__CVDUeNY3__"